import { db, functions } from "@/firebase";
import firebase from "firebase";
import { parDiasComparar } from "@/utils/dias.utils.js";
import { restSinNegocio2 } from "@/utils/restaurantes.utils.js";
import moment from "moment";
export default {
	setRangoDefecto({ commit, rootState }) {
		let hora = rootState.horaInicio;
		let fServidor = firebase.firestore.FieldValue.serverTimestamp();
		//fServidor = fServidor.toDate();
		let actual = moment(fServidor).hour();
		var res = [];

		let m = moment(fServidor).hour(parseInt(hora)).minute(0).seconds(0);
		if (actual > hora) {
			let hoy = m.utc().toDate();
			let tomorrow = m.add(1, "days").utc().toDate();
			res = [hoy, tomorrow];
		} else {
			let hoy = m.utc().toDate();
			let ayer = m.subtract(1, "days").utc().toDate();
			res = [ayer, hoy];
		}
		commit("setRango", res);
	},
	getPedidosGlobal({ state, commit, dispatch }) {
		const dias = parDiasComparar();
		return dispatch("setRangoDefecto").then(() => {
			var snap = db
				.collection("pedidos")
				.where("fechaServidor", ">=", dias[0])
				.where("fechaServidor", "<=", dias[1])
				.where("estado", "==", "finalizado")
				.onSnapshot((snapDoc) => {
					var res = [];
					snapDoc.forEach((e) => {
						let d = e.data();
						d.id = e.id;
						res.push(d);
					});
					commit("setPedidosArray", res);
					return;
				});
			//commit('app/addTiempoReal', snap, { root: true })
		});
	},
	getPedidosGlobalPendientePago({ state, commit, dispatch }) {
		const dias = parDiasComparar();
		return dispatch("setRangoDefecto").then(() => {
			var snap = db
				.collection("pedidos")
				.where("fechaServidor", ">=", dias[0])
				.where("fechaServidor", "<=", dias[1])
				.where("estado", "==", "pendiente_confirmacion_pago")
				.onSnapshot((snapDoc) => {
					var res = [];
					snapDoc.forEach((e) => {
						let d = e.data();
						d.id = e.id;
						res.push(d);
					});
					commit("setPedidosPendienteConfirmacionPago", res);
					return;
				});
			//commit('app/addTiempoReal', snap, { root: true })
		});
	},
	getPedidosEliminar({ commit }) {
		const dias = parDiasComparar();
		var snap = db
			.collection("pedidos")
			.where("fechaServidor", ">=", dias[0])
			.where("fechaServidor", "<=", dias[1])
			.where("estado", "==", "finalizado")
			.where("solicitarEliminado", "==", true)
			.onSnapshot((snapDoc) => {
				var res = [];
				snapDoc.forEach((e) => {
					let d = e.data();
					d.id = e.id;
					res.push(d);
				});
				commit("setPedidosEliminar", res);
				return;
			});
		//commit('app/addTiempoReal', snap, { root: true })
	},
	getPedidosRestaurante({ state, commit, dispatch, rootState }) {
		const dias = parDiasComparar();
		var consultas = [];
		const negocio = rootState.app.negocioGest;
		rootState.app.restauranteGest.forEach((rest) => {
			let restConsultar = restSinNegocio2(rest, negocio);
			const snap = db
				.collection("pedidos")
				.where("fechaServidor", ">=", dias[0])
				.where("fechaServidor", "<=", dias[1])
				.where("restaurante", "==", restConsultar)
				.where("negocio", "==", negocio)
				.where("estado", "==", "finalizado")
				.onSnapshot((snapDoc) => {
					var res = [];
					snapDoc.forEach((e) => {
						let d = e.data();
						d.id = e.id;
						res.push(d);
					});
					commit("setPedidosRestaurante", {
						id: rest,
						array: res,
					});
				});
			commit("app/addTiempoReal", snap, { root: true });
		});
	},
	getPedidosNegocio({ state, commit, rootGetters, rootState }) {
		const dias = parDiasComparar();
		var consultas = [];

		const role = rootGetters["auth/role"];
		var id;
		if (role == "admin") {
			let negocio = rootGetters["app/negocioGestObj"];
			id = negocio.id;
		} else {
			id = rootState.app.negocioGest;
		}
		const negocio = id;

		var snap = db
			.collection("pedidos")
			.where("fechaServidor", ">=", dias[0])
			.where("fechaServidor", "<=", dias[1])
			.where("negocio", "==", negocio)
			.where("estado", "==", "finalizado")
			.onSnapshot((snapDoc) => {
				var res = [];
				snapDoc.forEach((e) => {
					let d = e.data();
					d.id = e.id;
					res.push(d);
				});
				commit("setPedidosArray", res);
				return;
			});
		commit("app/addTiempoReal", snap, { root: true });
	},
	getPedidosNegocioRealizandoTpvCierre({ state, rootState, commit }, cierre) {
		console.log(cierre);
		const negocio = rootState.app.negocioGest;
		console.log("consultando pedidos del cierre " + cierre);
		var ref = db.collection("pedidos");
		ref = ref
			.where("zcierre", "==", cierre)
			.where("negocio", "==", negocio)
			.where("estado", "in", ["tpv-realizando", "finalizado"])
			.onSnapshot((snapDoc) => {
				console.log(
					snapDoc.docs.map((p) => {
						return {
							...p.data(),
							id: p.id,
						};
					})
				);
				commit("setPedidosRealizandoTpvPush", {
					cierre: cierre,
					pedidos: snapDoc.docs.map((p) => {
						return {
							...p.data(),
							id: p.id,
						};
					}),
				});
				return;
			});
	},
	getPedidosNegocioRealizandoTpv({ state, rootState, commit }) {
		const negocio = rootState.app.negocioGest;

		const dias = parDiasComparar();
		var ref = db.collection("pedidos");

		/*if (!!state.pedidosRealizandoTpvListener) state.pedidosRealizandoTpvListener()
    if (!!rootState.zcierre) {
      ref = ref.where('zcierre', '==', rootState.zcierre)
        .where('restaurante', '==', restSin)
        .where('negocio', '==', negocio)
        .where('estado', '==', 'tpv-realizando')
    } else {*/

		ref = ref
			.where("fechaServidor", ">=", dias[0])
			.where("fechaServidor", "<=", dias[1])
			//.where('restaurante', '==', restSin)
			.where("negocio", "==", negocio)
			.where("estado", "==", "tpv-realizando");
		//}
		ref.onSnapshot((snapDoc) => {
			console.log(
				snapDoc.docs.map((p) => {
					return {
						...p.data(),
						id: p.id,
					};
				})
			);
			commit(
				"setPedidosRealizandoTpv",
				snapDoc.docs.map((p) => {
					return {
						...p.data(),
						id: p.id,
					};
				})
			);
			return;
		});
		// return ref;
	},
	getPedidosDirectorio({ state, commit, rootGetters, rootState }) {
		const dias = parDiasComparar();

		const directorio = rootState.app.directorioGest;

		var snap = db
			.collection("pedidos")
			.where("fechaServidor", ">=", dias[0])
			.where("fechaServidor", "<=", dias[1])
			.where("directorio", "==", directorio)
			.where("estado", "==", "finalizado")
			.onSnapshot((snapDoc) => {
				var res = [];
				snapDoc.forEach((e) => {
					let d = e.data();
					d.id = e.id;
					res.push(d);
				});
				commit("setPedidosArray", res);
				return;
			});
		commit("app/addTiempoReal", snap, { root: true });
	},
	getPedido({ state }, id) {
		return db
			.collection("pedidos")
			.doc(id)
			.get()
			.then((r) => {
				if (r.exists) {
					return r.data();
				} else {
					return Promise.reject("No se encuetra el id " + id);
				}
			});
	},
	refundPedido({}, pedido) {
		var refund = functions.httpsCallable("httpStripeRefundPago");
		return refund(pedido);
	},
	imprimirPedido({}, pedido) {
		var imp = functions.httpsCallable("httpPedidosImprimirAdmin");
		return imp(pedido);
	},
	mapearPedido({}, pedido) {
		console.log(pedido);
		var mapear = functions.httpsCallable("httpPedidosMapearAdmin");
		return mapear(pedido);
	},
	eliminarPedido({ rootState }, payload) {
		const id = payload.idpedido;
		const motivo = payload.motivo;
		var promesas = [];
		promesas.push(
			db
				.collection("pedidos")
				.doc(id)
				.set(
					{
						eliminado: true,
						solicitarEliminado: false,
						eliminadoMotivo: motivo,
						historial: firebase.firestore.FieldValue.arrayUnion({
							fecha: moment().unix(),
							usuario: rootState.auth.user.email
								? rootState.auth.user.email
								: rootState.auth.user.uid,
							mensaje: "Pedido eliminado",
							adicional: {
								tipo: "eliminado",
								eliminadoMotivo: motivo,
							},
						}),
					},
					{ merge: true }
				)
		);
		if (payload.multipleHijos) {
			promesas.push(
				payload.multipleHijos.map((p) => {
					return db
						.collection("pedidos")
						.doc(p)
						.set(
							{
								eliminado: true,
								solicitarEliminado: false,
								eliminadoMotivo: motivo,
								historial:
									firebase.firestore.FieldValue.arrayUnion({
										fecha: moment().unix(),
										usuario: rootState.auth.user.email
											? rootState.auth.user.email
											: rootState.auth.user.uid,
										mensaje:
											"Pedido eliminado por el matriz",
										adicional: {
											tipo: "eliminado",
											eliminadoMotivo: motivo,
										},
									}),
							},
							{ merge: true }
						);
				})
			);
		}
		return Promise.all(promesas);
	},
	pasarPedido({ rootState }, payload) {
		var pasar = functions.httpsCallable("httpPedidosPasarRestaurante");
		return pasar(payload);
	},
	marcarImpreso({ rootState }, pedido) {
		return db
			.collection("pedidos")
			.doc(pedido.id)
			.set(
				{
					printNodeEstado: "imprimido",
					historial: firebase.firestore.FieldValue.arrayUnion({
						fecha: moment().unix(),
						usuario: rootState.auth.user.email
							? rootState.auth.user.email
							: rootState.auth.user.uid,
						mensaje: "Marcado impreso",
					}),
				},
				{ merge: true }
			);
	},
	comprobarImpreso({ rootState }, pedido) {
		var comprobar = functions.httpsCallable(
			"httpPrintnodeComprobarImpresion"
		);
		return comprobar(pedido);
	},
	comprobarPedidoPendientePago({ rootState }, pedido) {
		var comprobar = functions.httpsCallable(
			"httpStripeComprobarPedidoPendientePago"
		);
		return comprobar(pedido);
	},

	getPedidosPartner({ state, commit, dispatch, rootState }) {
		const dias = parDiasComparar();
		var consultas = [];
		rootState.app.partnerNegocios.forEach((negocio) => {
			console.log(negocio);
			const snap = db
				.collection("pedidosLigero")
				.where("fechaServidor", ">=", dias[0])
				.where("fechaServidor", "<=", dias[1])
				.where("negocio", "==", negocio)
				.where("estado", "==", "finalizado")
				.onSnapshot((snapDoc) => {
					var res = [];
					snapDoc.forEach((e) => {
						let d = e.data();
						d.id = e.id;
						res.push(d);
					});
					commit("setPedidosPartner", {
						id: negocio,
						array: res,
					});
				});
			commit("app/addTiempoReal", snap, { root: true });
		});
	},
	buscarPedidosSolicitadosEliminacion() {
		return db
			.collection("pedidos")
			.where("solicitarEliminado", "==", true)
			.orderBy("fechaServidor", "desc")
			.get()
			.then((r) => {
				return r.docs.map((p) => {
					return {
						...p.data(),
						id: p.id,
					};
				});
			});
	},
	mostrarAbonados() {
		return (
			db
				.collection("pedidos")
				.where("forma_pago", "==", "tarjeta_online")
				//.where("stripeCobrado", "!=", "refund")
				.orderBy("abonoCreado", "desc")
				.get()
				.then((r) => {
					return r.docs
						.map((p) => {
							return {
								...p.data(),
								id: p.id,
							};
						})
						.filter((p) => p.stripeCobrado != "refund");
				})
		);
	},
	buscarPedidos({}, payload) {
		var ref = db.collection("pedidos");
		if (payload.rest) {
			ref = ref.where("restaurante", "==", payload.rest.rest);
			ref = ref.where("negocio", "==", payload.rest.negocio);
		}
		if (payload.numPedidoRest) {
			ref = ref.where(
				"numPedidoRest",
				"==",
				parseInt(payload.numPedidoRest)
			);
		}
		if (payload.numPedidoRestDia) {
			ref = ref.where(
				"numPedidoRestDia",
				"==",
				parseInt(payload.numPedidoRestDia)
			);
		}
		return ref
			.orderBy("fechaServidor", "desc")
			.limit(30)
			.get()
			.then((r) => {
				console.log(r.size);
				return r.docs.map((p) => {
					return {
						...p.data(),
						id: p.id,
					};
				});
			})
			.catch((e) => console.log(e));
	},
};
